import styles from "@styles/pages/cdp/targeting-guide.module.scss";
import classNames from "classnames/bind";
import { If } from "shared/components/control-statements";
import { getAskedForLabel } from "../segmentations/Segments";
import { getSegments, groupSegments } from "./TargetingGuide";
const css = classNames.bind(styles);

export default function Conditions({
  selected_segments,
  appliedSegments,
  onRemove,
}) {
  const { inApplied, notInApplied } = groupSegments(
    selected_segments,
    appliedSegments
  );

  const applied = getSegments(inApplied);
  const notApplied = getSegments(notInApplied);

  const variables = [
    "Unidade",
    "Marca",
    "Origem",
    "Bairro",
    "Cidade",
    "Estado",
  ];

  return (
    <div className={styles.conditionsContainer}>
      <If cond={notApplied.length > 0}>
        <div className={styles.conditions}>
          {notApplied.length > 0 &&
            notApplied.map((condition, index) => {
              const askedFor = variables.includes(condition.key);

              return (
                <div className={styles.condition} key={index}>
                  <div className="d-flex flex-column">
                    <p className={styles.name}>
                      {notApplied.find((o) => o.id === condition.id).key}
                    </p>
                    <p className={styles.rule}>
                      {askedFor && getAskedForLabel(condition?.modifier)}{" "}
                      {condition.name}
                    </p>
                  </div>

                  <div className="d-flex align-center">
                    {/* <span className={styles.quantity}>
                      {Number(
                        condition.data?.[condition?.modifier?.id] || 0
                      ).toLocaleString("pt-BR")}
                    </span> */}
                    <div className={styles.divisor} />
                    <div
                      className={styles.remove}
                      onClick={() => onRemove(condition)}
                    >
                      <i className="fas fa-circle-xmark" />
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </If>

      <If cond={applied.length > 0}>
        <div className={styles.alreadyExecuted}>
          <p>Já executados</p>
        </div>

        <div className={styles.appliedConditions}>
          {applied.map((condition, index) => {
            const askedFor = variables.includes(condition.key);

            return (
              <div
                className={css({ condition: true, applied: true })}
                key={index}
              >
                <div className="d-flex flex-column">
                  <p className={styles.name}>
                    {applied.find((o) => o.id === condition.id).key}
                  </p>

                  <p className={styles.rule}>
                    {askedFor && getAskedForLabel(condition?.modifier)}{" "}
                    {condition.name}
                  </p>
                </div>

                <div className="d-flex align-center">
                  {/* <span className={styles.quantity}>
                    {Number(
                      condition.data?.[condition?.modifier?.id] || 0
                    ).toLocaleString("pt-BR")}
                  </span> */}
                  <div className={styles.divisor} />
                  <div
                    className={styles.remove}
                    onClick={() => onRemove(condition)}
                  >
                    <i className="fas fa-circle-xmark" />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </If>

      <If cond={applied.length === 0 && notApplied.length === 0}>
        <div className="h-100 d-flex flex-col align-center justify-center">
          <p className={styles.emptyText}>Nenhuma segmentação aplicada</p>
        </div>
      </If>
    </div>
  );
}
